import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subscription-module',
  templateUrl: './subscription-module.component.html',
  styleUrls: ['./subscription-module.component.css']
})
export class SubscriptionModuleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
